import { Theme, css } from "@emotion/react"

export const contentContainer = (theme: Theme) => css`
	display: grid;
	grid-template-columns: auto 1fr;
	column-gap: 3rem;

	${theme.breakpoints.down("sm")} {
		grid-template-columns: auto;
		column-gap: 0;
	}
`

export const sideBarFilter = (theme: Theme) => css`
	${theme.breakpoints.down("sm")} {
		display: none;
	}
`

export const mainContentArea = css`
	min-width: 0;
`

export const filterButton = (theme: Theme) => css`
	border-radius: 0.5rem;
	border: 1px solid #374151;
	padding: 0.7rem 1rem;
	font-size: 0.8rem;
	color: #374151;

	> span {
		font-weight: 500;
	}

	${theme.breakpoints.up("md")} {
		display: none;
	}
`

export const gridPartCard = css`
	display: flex;
`

export const partCardStyle = css`
	height: 100%;
	width: 100%;
`

export const resultStyle = (theme: Theme) => css`
	margin-bottom: 0;

	${theme.breakpoints.down("md")} {
		margin-bottom: 2rem;
	}
`

export const filterHeader = (theme: Theme) => css`
	display: block;
	align-items: center;
	justify-content: space-between;
	padding-right: 1rem;
`

export const searchResultsStatusHeaderStyle = (theme: Theme) => css`
	display: flex;
	align-items: center;
	justify-content: space-between;

	> div {
		align-self: normal;
	}

	${theme.breakpoints.down("sm")} {
		flex-direction: column;
		align-items: space-between;
	}
`

export const snapSearchStyle = css`
	color: #111827;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
`

export const visualSearchDescriptionStyle = css`
	color: #374151;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	margin-top: 5px;
`

export const noResultsIconBoxStyle = css`
	border-radius: 32px;
	border: 1px solid var(--Neutrals-300, #d1d5db);
	background: var(--Neutrals-100, #f3f4f6);
`

export const noResultsHeadingStyle = css`
	color: var(--Neutrals-900, #111827);
	font-family: "Atlas Grotesk";
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;

	span {
		font-weight: 700;
	}
`

export const noResultsDescriptionStyle = css`
	color: var(--Neutrals-500, #6b7280);
	text-align: center;
	font-family: "Atlas Grotesk";
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
`

export const visualSearchIconBoxStyle = css`
	display: flex;
	padding: 24px;
	justify-content: start;
	align-items: flex-start;
	gap: 10px;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	background: #f3f4f6;
`

export const snapSearchBoxStyle = css`
	margin-left: 12px;
	padding-right: 48px;
`
